import type { ReactNode } from "react";

import { styled } from "simplydo/react/styled";
import { DropdownItem } from "simplydo/react/ui/dropdown";

const ItemContainer = styled(DropdownItem)`
  display: flex;
  flex-direction: row;
  align-items: center;
  .company-info {
    margin-left: 5px;
    display: flex;
    flex-direction: column;
    span {
      display: block;
      margin: 0;
    }
    .description {
      opacity: 0.7;
    }
  }
`;

type StyledDropdownItemProps = {
  text: string;
  description?: string;
  image?: ReactNode;
  value?: string;
  onClick?: () => void;
};

const StyledDropdownItem = ({
  text,
  description,
  image,
  value,
  onClick,
}: StyledDropdownItemProps) => {
  return (
    <ItemContainer onClick={onClick} value={value}>
      {image}
      <div className="company-info">
        <span>{text}</span>
        {description ? (
          <span className="description">{description}</span>
        ) : null}
      </div>
    </ItemContainer>
  );
};

export default StyledDropdownItem;
